import axios from 'axios';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { rejectPhantomResponses } from './phantom-response';

// Native replacement for lodash capitalize: upper-case the first char, lower-case the rest.
const capitalize = str => (str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : str);

const tokenEl = document && document.querySelector('meta[name="csrf-token"]');
const CSRFToken = tokenEl && tokenEl.getAttribute('content');

const api = axios.create({
  headers: {
    'X-CSRF-Token': CSRFToken,
  },
  // Techo global: sin timeout (default 0 = infinito), un request colgado deja
  // los estados "cargando" absorbentes para siempre (el botón Reintentar de
  // las cadenas de recuperación nunca aparece). La exención de uploads de
  // abajo es PREVENTIVA: hoy KYC/comprobantes suben por fetch crudo o form
  // nativo (no por esta instancia), pero el día que alguien los mueva aquí,
  // una foto por 3G real no debe morir a los 20s.
  timeout: 20000,
});

// PRIMERO (los interceptores de response corren en orden de registro): las
// respuestas fantasma con status 0 se vuelven rechazos ANTES de que el
// camelizador o cualquier .then() las trate como datos (ARCADI-EP/F4).
api.interceptors.response.use(rejectPhantomResponses);

api.interceptors.response.use(
  response => {
    if (response.data && response.headers['content-type'].match('application/json')) {
      response.data = camelizeKeys(response.data);
    }

    return response;
  },
  error => {
    if (error.response) {
      const { data } = error.response;
      switch (data.message) {
      case 'invalid_attributes':
        error.details = Object.entries(data.errors)
          .map(([attribute, errorMessage]) => capitalize(`${attribute} ${errorMessage}`));
        break;
      case 'server_error':
        // El API ya no manda el detalle de la excepción (queda en Sentry).
        error.details = ['Error interno del servidor'];
        break;
      default:
        break;
      }
    }

    return Promise.reject(error);
  },
);

api.interceptors.request.use(config => {
  const newConfig = { ...config };
  // Cubre también el uso idiomático api.post(url, formData) sin header manual
  // (axios setea el multipart boundary solo): mismo trato — sin techo de
  // timeout y sin decamelizar el FormData.
  const isFormData = typeof FormData !== 'undefined' && newConfig.data instanceof FormData;
  if (newConfig.headers['Content-Type'] === 'multipart/form-data' || isFormData) {
    newConfig.timeout = 0; // uploads: sin techo, 3G real
    return newConfig;
  }
  if (config.params) {
    newConfig.params = decamelizeKeys(config.params);
  }
  if (config.data) {
    newConfig.data = decamelizeKeys(config.data);
  }

  return newConfig;
});

export default api;
